import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BatchService} from '../../batchstamp/batch.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'modal-delete-stamp',
  templateUrl: './modalDeleteStamp.template.html',
  styleUrls: ['./modalDeleteStamp.component.css'],
  providers: [BatchService],
})
export class ModalDeleteStampComponent implements OnInit {
  batch_detail: any;
  btnClose: string;
  btnConfirm: string;
  cModalTitle: string;
  @Output() refreshListStamp = new EventEmitter<'refresh'>();

  constructor(
    public bsModalRef: BsModalRef,
    private batchService: BatchService,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit() {
  }

  confirmDelete() {
    console.log('this.batch_detail', this.batch_detail)
    // return
    this.batchService
      .deleteBatchStamp(this.batch_detail.id)
      .toPromise()
      .then((res: any) => {
        console.log('res', res)
        if (res.code == 1) {
          const mess = 'Xóa lô tem thành công';
          this.toastr.success(mess, 'Thành công:', {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        } else {
          const mess = res.message
            ? res.message
            : 'Thao tác chưa thành công. Vui lòng thử lại sau!';
          this.toastr.warning(mess, 'Thông báo:', {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
        this.refreshListStamp.emit('refresh');
      })
      .catch((err: any) => {
        const mess = 'Có lỗi xảy ra. Vui lòng thử lại sau!';
        this.toastr.warning(mess, 'Thông báo:', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        })
      });
    this.bsModalRef.hide()
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/confirmDeleteStamp/modalDeleteStamp.component.ts